import React from 'react';
import { Box } from '@fiverr-private/theme';
import type { TooltipEllipsisProps } from '../types';

const TooltipEllipsis = ({ children, lines }: TooltipEllipsisProps) => (
  <Box
    overflow="hidden"
    textOverflow="ellipsis"
    wordBreak="breakAll"
    {...(lines
      ? { webkitLineClamp: lines, display: 'webkitBox', webkitBoxOrient: 'vertical' }
      : { overflowWrap: 'breakWord', whiteSpace: 'nowrap' })}
  >
    {children}
  </Box>
);

export default TooltipEllipsis;
